<template>
    <div style="margin: 14px">
        <span v-if="noMore_">没有更多了</span>
        <el-button v-else
                   :loading="nextLoading"
                   type="primary"
                   @click="loadNext"
                   size="mini"
                   round>加载更多
        </el-button>

        <!-- 订单编辑界面 -->

    </div>
</template>

<script>
    export default {
        name: "NextFoo",
        props: {
            noMore: {
                type: Boolean,
                default:undefined
            },
            nextUrl: {
                required: true
            },
            handleResponse: {
                type: Function,
                default: function () {
                    return () => {
                    }
                },
            }
        },
        data() {
            return {
                nextLoading: false,
            }
        },
        computed: {
            noMore_() {
                if (this.noMore === undefined) {
                    return !Boolean(this.nextUrl)
                }
                return this.noMore
            },
        },
        methods: {
            loadNext() {
                this.nextLoading = true
                this.$getRequest(this.nextUrl)
                    .then(response => {
                        this.nextLoading = false
                        this.handleResponse(response)
                    })
                    .catch(error => {
                        this.nextLoading = false
                    })
            },
        },
    }
</script>

<style scoped>

</style>